import type { Routes } from '@angular/router';

import { ListingResolver } from './pages/listing/listing.resolver';

export const ConfiguredRoutes: Routes = [
  { loadComponent: () => import('./pages/home/home.page').then((m) => m.HomePage), path: '' },
  {
    loadComponent: () => import('./pages/listing/listing.page').then((m) => m.ListingPage),
    path: ':id',
    resolve: { listing: ListingResolver },
  },
  { path: '**', redirectTo: '' },
];
